import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import {Observable, tap} from 'rxjs';
import {UserPermissionsService} from 'src/app/services/user-permissions.service';
import {switchMap} from 'rxjs/operators';
import {AuthService} from '../../auth/shared/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class UserPermissionGuard implements CanActivate, CanActivateChild {
  constructor(
    private userPermissionsService: UserPermissionsService,
    private router: Router,
    private authService: AuthService,
  ) {}

  checkPermissions(route: ActivatedRouteSnapshot) {
    return this.userPermissionsService.checkUserPermissions(route.data.permissions).pipe(
      tap(hasPermission => {
        if (!hasPermission) {
          this.router.navigate(['/']);
        }
      }),
    );
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.userPermissionsService.onceLoaded) {
      return this.checkPermissions(route);
    }

    return this.authService.loadUserOrTeamDataBasedOnSwitch().pipe(
      switchMap(({data}) => this.userPermissionsService.loadUserPermissions(data.user.ssoUserId)),
      switchMap(newData => {
        return this.checkPermissions(route);
      }),
    );
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate(childRoute, state);
  }
}
